export default __webpack_public_path__ + "assets/images/13dd7aa992bcef990689d16633175059.jpg";